module.exports = __webpack_public_path__ + "img/lecce-logo-icon.c148b579.png";